import { useTranslation } from 'react-i18next';
import { MessageBar, MessageBarBody } from '@fluentui/react-components';

// The error-state rule (docs/error-states-audit-2026-10-21.md, STX-PROD-05): every load whose ABSENCE could be read as a
// value (an empty list, a zero, a blank column) renders its own failure. A page's primary load already shows its error;
// this is the one warning for its SECONDARY loads, naming exactly which parts failed so a blank or a zero is never read as
// the client's data.

export type SecondaryPart = 'clients' | 'billing' | 'taxTypes' | 'filingHealth' | 'snoozes' | 'bookkeeping' | 'nextDue';

export default function SecondaryLoadWarning({ failed }: { failed: Array<SecondaryPart | false | null | undefined> }) {
  const { t } = useTranslation();
  const parts = failed.filter((p): p is SecondaryPart => typeof p === 'string');
  if (parts.length === 0) return null;
  return (
    <MessageBar intent="warning" data-testid="secondary-load-warning">
      <MessageBarBody>
        {t('common.secondaryLoad.message', { parts: parts.map((p) => t(`common.secondaryLoad.parts.${p}`)).join(', ') })}
      </MessageBarBody>
    </MessageBar>
  );
}
